/* K MANNAM v11 — product-card countdown. No app, jQuery, network request or reset-on-visit. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('km-product-countdown')) return;
  const active = new Set();
  let timer = 0;
  const stop = () => { if (timer) window.clearTimeout(timer); timer = 0; };
  const schedule = () => {
    if (timer || !active.size || document.hidden) return;
    // Align to wall-clock seconds. Recompute from the absolute deadline at every tick.
    timer = window.setTimeout(() => {
      timer = 0;
      const now = Date.now();
      for (const element of Array.from(active)) {
        if (element.isConnected) element.update(now);
        else active.delete(element);
      }
      schedule();
    }, 1000 - Date.now() % 1000 + 8);
  };
  class KMProductCountdown extends HTMLElement {
    static get observedAttributes() { return ['data-end', 'data-day-label']; }
    connectedCallback() {
      this._output = this.querySelector('[data-km-countdown]');
      this._end = Number(this.getAttribute('data-end')) * 1000;
      if (!this._output) return; // Deferred asset runs after parsing; no empty node mutation.
      active.add(this);
      this.update(Date.now());
      schedule();
    }
    disconnectedCallback() {
      active.delete(this);
      if (!active.size) stop();
    }
    attributeChangedCallback() { if (this.isConnected) this.connectedCallback(); }
    update(now) {
      const seconds = Math.ceil((this._end - now) / 1000);
      if (!Number.isFinite(this._end) || this._end <= 0 || seconds <= 0) {
        this.hidden = true;
        active.delete(this);
        const card = this.closest('.product-item');
        if (card) {
          card.classList.remove('km-product--has-deal', 'km-product--featured-deal');
          card.querySelectorAll('[data-km-deal-feature]').forEach(label => { label.hidden = true; });
        }
        if (!active.size) stop();
        return;
      }
      this.hidden = false;
      const card = this.closest('.product-item');
      if (card) {
        card.classList.add('km-product--has-deal');
        const label = card.querySelector('[data-km-deal-feature]');
        if (label) { label.hidden = false; card.classList.add('km-product--featured-deal'); }
      }
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor(seconds % 86400 / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const pad = n => String(n).padStart(2, '0');
      const text = (days ? `${days}${this.dataset.dayLabel || 'd'} ` : '') + `${pad(hours)}:${pad(minutes)}:${pad(seconds % 60)}`;
      if (this._output.textContent !== text) this._output.textContent = text;
    }
  }
  customElements.define('km-product-countdown', KMProductCountdown);
  const refresh = () => {
    stop();
    if (!document.hidden) {
      for (const element of Array.from(active)) element.update(Date.now());
      schedule();
    }
  };
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
})();
